import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import {
  Auth, SatCoreComponent, assignmentManager, classroomManager,
  contentManager, courseManager, dialogManager, gradebookManager,
  i18nAddSatellite, navigationManager, userManager
} from 'sat-core';
import { API_ROOT, LESSON_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE } from './api-config';

import iconCommentActiveYellow from './img/icon-comment-active-yellow.svg';
import logo from './img/ballard-tighe-logo-sm.png';

import 'semantic-ui-less/semantic.less';
import './index.less';
import * as serviceWorker from './serviceWorker';

/* Put component override imports here */
import './views/MainViewOverride';
import './views/LoginOverride';
import './views/ProgressViewOverride';
import './components/CourseListBannerOverride';
import './services/AccommodationsServiceOverride';
import './services/BtBannerServiceOverride';

import btTranslations from './btTranslations';

i18nAddSatellite('bt', btTranslations);

const App = SatCoreComponent('App');
Auth.init(API_ROOT, PUBLISHER_ROOT, PUBLISHER_SATELLITE_CODE, logo, LESSON_ROOT);
// accommodationsManager.setIncludeAssignmentAccommodations(true);
// accommodationsManager.setIncludeClassroomAccommodations(true);
assignmentManager.setEnableCourseSearch(true);
assignmentManager.setLateSubmissionOptionAllowed(false);
assignmentManager.setAllowPresentationMode(true);
classroomManager.setEnabledStudentsOnly(false);
classroomManager.setIncludeGroups(true);
contentManager.setFeedbackIconActiveImg(iconCommentActiveYellow);
contentManager.setResourceIFrameUrl('https://www.ballard-tighe.com/helpdesk');
contentManager.setResourceIFrameUrlStudent('https://www.ballard-tighe.com/helpdesk4students/');
courseManager.setAllowStudentBooks(false);
gradebookManager.setAllowAssignmentLink(true);
gradebookManager.setAllowGradebookStandards(true);
userManager.setClientPrefix('BT');

ReactDOM.render(
  <Provider
    assignmentManager={assignmentManager}
    classroomManager={classroomManager}
    contentManager={contentManager}
    courseManager={courseManager}
    dialogManager={dialogManager}
    gradeBookManager={gradebookManager}
    navigationManager={navigationManager}
    userManager={userManager}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
